var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsageReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19.5,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#34a3dc",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    rx: 1,
    width: 3,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 3,
    height: 13,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 3,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 3,
    height: 5,
    rx: 1.001
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageReports);
export default __webpack_public_path__ + "static/media/usage_reports.bb7adc48bb9edbf73d6274bb5bc574d5.svg";
export { ForwardRef as ReactComponent };